// Ad Preview Stage 3 multi-location amendment §A4. Client-side mirror
// of the public DTO returned by /api/public/preview-contact/:token
// (server in server/modules/previewSends/publicContactRouter.ts). The
// server hand-curates the payload field by field, so this client type
// must stay in lock-step with `assembleContactDto`.
//
// Lives in the preview module (not src/types/) because nothing outside
// the public summary page consumes it.

export type MyPreviewCard = {
  // The individual PreviewLink token. The page builds
  // `${origin}/preview/${previewToken}` for the card's link.
  previewToken: string;
  locationDisplayName: string;
  // ISO-8601 expiry of this individual preview link.
  expiresAt: string;
  // Channels the preview shows (server-decided).
  channels: { meta: boolean; google: boolean };
};

export type MyPreviewsDto = {
  status: 'ok';
  token: string;
  // May be empty when the contact was deleted after the send.
  contactName: string;
  brandName: string;
  // First preview's Campaign name, used as the batch label (v1).
  campaignName: string;
  // Earliest expiry across the shown previews (the urgency cutoff).
  expiresAt: string;
  previews: MyPreviewCard[];
};

export type MyPreviewsResponse =
  | MyPreviewsDto
  | { status: 'not_found' }
  | { status: 'revoked' }
  | { status: 'expired'; expiresAt: string };

// Wording on a summary card follows the channels the preview really shows.
export function previewCardChannelText(
  channels: { meta: boolean; google: boolean } | undefined,
): string {
  // A response from before channels existed carries none: both, as it always was.
  const c = channels ?? { meta: true, google: true };
  if (c.meta && c.google) return 'Meta + Google ads ready to review';
  if (c.meta) return 'Meta ads ready to review';
  if (c.google) return 'Google ads ready to review';
  return 'Nothing to review for this location';
}
